import {
  AfterViewInit,
  Directive,
  Input,
  OnChanges,
  SimpleChanges,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { isNullable } from '@qtek/shared/utils';

@Directive({
  selector: '[qtDetailRow]',
  standalone: false,
})
export class DetailRowDirective<T> implements AfterViewInit, OnChanges {
  /** Row data. */
  @Input('qtDetailRow') row: T;

  /** Hidden row template. */
  @Input('qtDetailRowTemplate') template: TemplateRef<any>;

  /** Whether view should be shown or not. */
  @Input('qtDetailRowOpened')
  set opened(value: boolean) {
    this.isOpen = value;

    if (isNullable(this.template)) {
      return;
    }

    this.changeOpenStatus(value);
  }

  private isOpen = false;

  constructor(private viewContainerRef: ViewContainerRef) {}

  ngAfterViewInit(): void {
    this.changeOpenStatus(this.isOpen);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['row'] && this.isOpen) {
      this.setViewRef();
    }
  }

  private changeOpenStatus(value: boolean): void {
    if (value) {
      this.setViewRef();
    } else {
      this.viewContainerRef.clear();
    }
  }

  private setViewRef(): void {
    this.viewContainerRef.clear();

    const viewRef = this.viewContainerRef.createEmbeddedView(this.template, {
      $implicit: this.row,
    });
    viewRef.detectChanges();
  }
}
